import React from "react";
import PropTypes from "prop-types";
import { mergeClasses } from "@fluentui/react-components";
import { useComboboxStyles } from "../styles/comboboxStyles";

const ComboboxPathOptionText = ({ name, pathLabel, parentPath, nameClassName }) => {
  const comboboxStyles = useComboboxStyles();

  return (
    <span className={comboboxStyles.optionTextColumn}>
      <span className={mergeClasses(comboboxStyles.optionText, nameClassName)}>{name}</span>
      {parentPath ? (
        <span className={comboboxStyles.optionMetaText}>
          {pathLabel}: {parentPath}
        </span>
      ) : null}
    </span>
  );
};

ComboboxPathOptionText.propTypes = {
  name: PropTypes.string.isRequired,
  pathLabel: PropTypes.string.isRequired,
  parentPath: PropTypes.string,
  nameClassName: PropTypes.string,
};

export default ComboboxPathOptionText;
